import { RecorderKind } from 'modules/video-markers/domain/interfaces';

export const RECORDER_KINDS: readonly RecorderKind[] = ['obs', 'vmix'];

/** Оверлей открыт внутри самой программы, поэтому по умолчанию она на этой же машине. */
export const DEFAULT_RECORDER_HOST = '127.0.0.1';

/** OBS — WebSocket-сервер (Инструменты → Настройки сервера WebSocket), vMix — Web Controller. */
export const DEFAULT_RECORDER_PORTS: Record<RecorderKind, number> = {
  obs: 4455,
  vmix: 8088,
};
